import { redirect } from 'react-router-dom';
import { useAuthStore } from '../../features/auth/authStore';

const protectedLoader = async () => {
  const auth = useAuthStore.getState().auth;

  console.log(auth);

  if (!auth) {
    throw redirect(`/auth/login`);
  }

  // if (requiredRole && auth?.memberships[0]?.role !== requiredRole) {

  //     throw redirect(`/not-authorized`);
  // }
};

export default protectedLoader;
